module.exports = __webpack_public_path__ + "integrately-logo-692d1309941d1650f6bdecfc91853527.webp";